module.exports = __webpack_public_path__ + "media/images/icons/flags/JP-60c65d001042ccb725d8fb7a06216aaa.svg";